import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';

import { AppComponentBase } from '@shared/common/app-component-base';
import { CreateOrEditMarkAttendanceMRRDto, EmployeePunchFailureCount, MarkAttendancesServiceProxy } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { PunchfailureViewComponent } from '../punchfailure-view/punchfailure-view.component';
import { FileDownloadService } from '@shared/utils/file-download.service';
@Component({
  selector: 'app-punch-failure-count',
  templateUrl: './punch-failure-count.component.html',
  styleUrls: ['./punch-failure-count.component.css']
})

export class PunchFailureCountComponent extends AppComponentBase {
  @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
  @ViewChild('PunchfailureView', { static: true }) PunchfailureView: PunchfailureViewComponent;
  EmployeePunchFailureCount: EmployeePunchFailureCount[] = [];
  data:EmployeePunchFailureCount[] = [];
  @Output() punchFailureUpdated: EventEmitter<any> = new EventEmitter(); // EventEmitter to notify other parts
  loading: { [key: string]: boolean } = {};
  resultPerPage: number = 10; // Initial value for records per page
  currentPage: number = 1;
  downloadingsheet: boolean = false;
  CreateOrEditMarkAttendanceMRRDto:CreateOrEditMarkAttendanceMRRDto
  punchFailureCount: number;
  total: number;
  constructor(
     injector: Injector,        
     private _markAttendanceAppSeriveProxy:MarkAttendancesServiceProxy,
     private _fileDownloadService: FileDownloadService,
     
 
   ) {
     super(injector);
   }

  ngOnInit() {
    this.getEmployeePunchFailures();
  }
  getEmployeePunchFailures(KraId?: number): void {
    
    
    this._markAttendanceAppSeriveProxy.getPunchFailureCounts().subscribe(result => {
      this.data = result;
      this.total=result.length;
      this.applyPagination() 
      //this.modal.show();
    });
  }
  applyPagination() {
    const start = (this.currentPage - 1) * this.resultPerPage; // Calculate the start index
    const end = start + this.resultPerPage; // Calculate the end index
    this.EmployeePunchFailureCount = this.data.slice(start, end); // Slice the data based on page and items per page
}
  handlePageChange(e) {
    // If currentPage is changed by the paginator
    if (e.first !== undefined) {
        this.currentPage = Math.floor(e.first / this.resultPerPage) + 1; // Convert to 1-indexed
    }

    // If resultPerPage is changed by the paginator
    if (e.rows !== undefined) {
        this.resultPerPage = e.rows;
    }

    this.applyPagination(); // Update the filtered data after page or result per page change
}
  close(){
    this.modal.hide();
  }
  getPunchFailureCount(){
    
    this._markAttendanceAppSeriveProxy.punchFailureCount().subscribe(result=>{
        this.punchFailureCount = result;
        
    });

    
}
  reprocess(biometricId?: any): void {
    this.loading[biometricId] = true;
    this._markAttendanceAppSeriveProxy.reprocessPunchByBiometricId(biometricId).subscribe(
      result => {
        this.loading[biometricId] = false;
        this.notify.success("Reprocess Successfully");
        this.getPunchFailureCount();
  this.punchFailureUpdated.emit();
        this.getEmployeePunchFailures();
      },
      error => {
       this.loading[biometricId] = false;
        if (error && error.error && error.error.message) {
          this.loading[biometricId] = false;
        } 
      }
  )}

  exportToExcel(): void {
          this.downloadingsheet = true;
          this._markAttendanceAppSeriveProxy.getPunchFailureForExcel().pipe(
            finalize(() => { this.downloadingsheet = false; }))
              .subscribe(result => {
                  this._fileDownloadService.downloadTempFile(result);
              });
       }
  }
